import {useState} from "react";

interface ButtonProps {
    type: string;
    text: string;
    onclick?: any;
    tooltip?: string;
    disabled?: boolean;

}

export default function Button(props: ButtonProps) {

    const {type, text, onclick, tooltip, disabled} = props
    const [isHover, setIsHover] = useState(false);

    const baseStyle = {
        color: isHover ? 'black' : '#FFFFFF',
        cursor: disabled ? 'auto' :'pointer',
        fontSize: '0.75rem',
        border: 'none',
        borderRadius: '5px',
        height: '100%',
        width: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '14px',
        minHeight: '24px',
        // outlineColor: '#c5ccd3'
        outline: 'none'
    }

    let btnPrimary = {...baseStyle, background: "#21409b"}
    // Previous Regular: background: 'linear-gradient(180deg, #4B91F7 0%, #367AF6 100%)'

    let btnDelete = {...baseStyle, background: disabled ? "#f58e9e" : "#e97c8c"}    // initial color: #e15167

    let btnSecondary = {...baseStyle, background: "#a8b3bd", cursor: "auto"}

    let btnOrange = {...baseStyle, background: "#d2a000"}

    let buttonStyle = {}
    if (type === "primary") {
        buttonStyle = btnPrimary
    } else if (type === "delete") {
        buttonStyle = btnDelete
    } else if (type === "secondary") {
        buttonStyle = btnSecondary
    } else if (type === "orange") {
        buttonStyle = btnOrange
    } else {
        buttonStyle = btnPrimary
    }


    const handleMouseEnter = () => {
        setIsHover(true);
    };
    const handleMouseLeave = () => {
        setIsHover(false);
    };

    return (
        <button
            name={text}
            type="button"
            // className={butClass}
            title={tooltip}
            onClick={onclick}
            disabled={disabled}
            style={buttonStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >{text}
        </button>
    )
}